const MobileRecognitionPointsView = () => {
  return 'PointsView'
}

export default MobileRecognitionPointsView
